"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModulePanel = void 0;
var react_1 = __importDefault(require("react"));
var ModuleCard_1 = require("../module-card/ModuleCard");
var core_1 = require("@material-ui/core");
var useStyles = core_1.makeStyles(function (theme) {
    return {
        paperContainer: {
            borderRadius: 4,
            maxWidth: 250,
            width: '100%',
            background: theme.palette.background.paper,
        },
        list: {
            padding: 0,
        },
    };
});
var ModulePanel = function (props) {
    var isOpen = props.isOpen, setPopoverClose = props.setPopoverClose, anchorEl = props.anchorEl, modules = props.modules;
    var classes = useStyles();
    return (react_1.default.createElement(core_1.Popover, { open: isOpen, onClose: setPopoverClose, anchorEl: anchorEl, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center',
        }, transformOrigin: {
            vertical: 'top',
            horizontal: 'center',
        }, PaperProps: { className: classes.paperContainer } },
        react_1.default.createElement(core_1.List, { className: classes.list, component: "nav" }, modules.map(function (_a) {
            var label = _a.label, link = _a.link;
            return react_1.default.createElement(ModuleCard_1.ModuleCard, { key: link, label: label, link: link });
        }))));
};
exports.ModulePanel = ModulePanel;
